import { createLayoutPortalToken } from '@sketch/utils'

export const header = createLayoutPortalToken('header')
export const headerSlim = createLayoutPortalToken('header-slim')
export const navbar = createLayoutPortalToken('navbar')
export const subHeader = createLayoutPortalToken('sub-header')
export const warnings = createLayoutPortalToken('warnings')
